<template>
    <div>
        <div class="flex flex-col justify-center items-center h-full">
            <div class="mb-4">
                <p class="text-left text-2xl">
                    ┻┳|<br>
                    ┳┻| _<br>
                    ┻┳| •.•)<br>
                    ┳┻|⊂ﾉ<br>
                    ┻┳|
                </p>
            </div>

            <h1 class="mb-2 text-3xl">
                {{ $t('global.errors.notFound.title') }}
            </h1>

            <p class="mb-8">
                {{ $t('global.errors.notFound.description') }}
            </p>

            <nio-button
                color="blue"
                tag="router-link"
                to="/"
            >
                {{ $t('global.errors.notFound.button') }}
            </nio-button>
        </div>
    </div>
</template>

<script>
    export default {
    };
</script>
